import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError, Observable, catchError } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  constructor(private httpClient: HttpClient) { }

  private handleError(error: any) {
    return throwError(error);
  }
  // Dashboard
  dashboard(): Observable<any> {
    return this.httpClient
      .get(environment.baseURL + `/dashboard`)
      .pipe(catchError(this.handleError));
  }

  // Total Employee
  totalEmployee(): Observable<any> {
    return this.httpClient
      .get(environment.baseURL + `/dashboard/totalEmployee`)
      .pipe(catchError(this.handleError));
  }

  // Total Job 
  totalOpportunities(): Observable<any> {
    return this.httpClient
      .get(environment.baseURL + `/dashboard/totalOpportunities`)
      .pipe(catchError(this.handleError));
  }

  // Total Company
  totalCompanies(): Observable<any> {
    return this.httpClient
      .get(environment.baseURL + `/dashboard/totalCompanies`)
      .pipe(catchError(this.handleError));
  }

  // Total Notification
  totalNotification(): Observable<any> {
    return this.httpClient
      .get(environment.baseURL + `/adminnotification/totalUnreadCount`)
      .pipe(catchError(this.handleError));
  }

  // Notification List
  NotificationList(): Observable<any> {
    return this.httpClient
      .get(environment.baseURL + `/adminnotification`)
      .pipe(catchError(this.handleError));
  }

  // Update Notification Table
  UpdateNotification(Id: any, data: any): Observable<any> {
    return this.httpClient
      .put(environment.baseURL + `/adminnotification/${Id}/update`, data)
      .pipe(catchError(this.handleError));
  }
}
